import * as api from './api';
import {
  showOrderedResponseDialog,
  showOrderSampleDetailsWindow,
  setMessageDialogParams
} from '../redux/fabricCanvasActions';
import { string } from '../localization';
import * as Constants from '../utilities/constants/Constants';
import { setProjectDetailsInRequestJSON } from '../redux/projectSaveAndLoader';

// Order sample and share via email actions
export const emailPreviewWithLoupeRecipients = (
  recipientList,
  aMessage,
  aSampleWindowJSON,
  dispatch,
  getState
) => {
  const wallArtLiteMode = getState().modal.envData.wallart_lite_mode;
  const aProject = getState().finalCheck.project;
  if (
    aProject === null ||
    aProject.name === null ||
    (!wallArtLiteMode && aProject.externalId === null) ||
    aProject.id === null
  ) {
    const dict = {
      header: '',
      description: 'Exception error',
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: null,
      buttonTitles: {
        finish: string.OK_KEY,
        cancel: ''
      }
    };
    dispatch(setMessageDialogParams(dict));
  }

  const recipientListAsString = recipientList;
  const storeId = getState().modal.storeData.id;
  const { walls, wallIndex } = aProject;
  const wallId = walls[wallIndex].id;
  const requestData = JSON.stringify({
    store_id: storeId,
    wall_id: wallId,
    recipient: recipientListAsString,
    message: aMessage,
    sample_window: aSampleWindowJSON
  });

  const postData = `request=${requestData}`;
  if (wallArtLiteMode) {
    const { id } = aProject;
    api
      .shareSamplePrintableSample(id, postData)
      .then(responseData => {
        dispatch(showOrderedResponseDialog(responseData.data));
      })
      .catch(err => {
        dispatch(showOrderSampleDetailsWindow(false));
        const dict = {
          header: '',
          description: err.message,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      });
  } else {
    const { externalId } = aProject;
    api
      .platformEmailSample(externalId, postData)
      .then(responseData => {
        dispatch(showOrderedResponseDialog(responseData.data));
      })
      .catch(err => {
        dispatch(showOrderSampleDetailsWindow(false));
        const dict = {
          header: '',
          description: err.message,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      });
  }
};

export const emailRecipientsWithMessageAboutProjectLinkType = (
  recipientList,
  inMessage,
  sharelinkType,
  dispatch,
  getState
) => {
  const wallArtLiteMode = getState().modal.envData.wallart_lite_mode;
  const aProject = getState().finalCheck.project;
  const storeId = getState().modal.storeData.id;
  let aMessage = inMessage;
  if (
    aProject === null ||
    aProject.name === null ||
    (!wallArtLiteMode && aProject.externalId === null) ||
    aProject.id === null
  ) {
    const dict = {
      header: '',
      description:
        ' Email_Error , reason:Project not specified or project name is not set',
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: null,
      buttonTitles: {
        finish: string.OK_KEY,
        cancel: ''
      }
    };
    dispatch(setMessageDialogParams(dict));
  }
  if (recipientList.length === 0) {
    const dict = {
      header: '',
      description: ' Email_Error , reason:RecipientList is empty',
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: null,
      buttonTitles: {
        finish: string.OK_KEY,
        cancel: ''
      }
    };
    dispatch(setMessageDialogParams(dict));
  }
  if (aMessage) {
    aMessage = aMessage.replace(/"\"/g, '\\"');
  }

  const recipientListAsString = recipientList;
  const requestData = JSON.stringify({
    store_id: storeId,
    recipient: recipientListAsString,
    message: encodeURIComponent(aMessage),
    link_type: sharelinkType
  });

  const postData = `request=${requestData}`;

  if (wallArtLiteMode) {
    const projectToken = getState().finalCheck.project.token;
    api
      .shareSampleViaEmailForWallartLite(projectToken, postData)
      .then(responseData => {
        dispatch(showOrderedResponseDialog(responseData.data));
      })
      .catch(() => {});
  } else {
    const { externalId } = aProject;
    api
      .shareSampleViaEmail(externalId, postData)
      .then(responseData => {
        dispatch(showOrderedResponseDialog(responseData.data));
      })
      .catch(() => {});
  }
};

export const saveProjectAtPath = (
  project,
  path,
  dispatch,
  getState,
  callback
) => {
  const wallArtLiteMode = getState().modal.envData.wallart_lite_mode;
  const folderSupport = getState().modal.envData.folder_support;
  if (project === null || project.name === null) {
    callback(null);
  }

  if (wallArtLiteMode) {
    dispatch(setProjectDetailsInRequestJSON()).then();
  }

  if (folderSupport && path === null) {
    callback(null);
  }

  let update = false;
  if (project && project.externalId) {
    update = true;
  }
  const { eCommerceServicesUrl } = getState().modal.storeData;
  let url = `${eCommerceServicesUrl}/projects`;
  let pathInfoParam = '/projects';
  if (update) {
    url = `${url}/${project.externalId}`;
    pathInfoParam = `${pathInfoParam}/${project.externalId}`;
  }

  const storeId = getState().modal.storeData.id;
  const { externalId, name } = project;
  const contentContextToken = getState().modal.envData.content_context_token;
  const requestDataJSON = {
    id: externalId,
    store_id: storeId,
    content_context_token: contentContextToken,
    path,
    name,
    path_info: pathInfoParam,
    service_url: url
  };

  const sendContentContextToken = !(
    contentContextToken === null || contentContextToken === ''
  );

  if (!sendContentContextToken) {
    delete requestDataJSON.content_context_token;
  }
  if (!folderSupport) {
    delete requestDataJSON.path;
  }

  const requestData = JSON.stringify(requestDataJSON);
  const postData = `request=${escape(requestData)}`;

  api
    .saveForWebLink(postData)
    .then(responseData => {
      const projectJson = responseData.data;
      if (sendContentContextToken) {
        if (
          projectJson.id === null ||
          projectJson.name === null ||
          projectJson.content_context_token === null ||
          projectJson.state === null
        ) {
          if (folderSupport && projectJson.path === null) {
            callback(null);
          }
        }
      } else if (!projectJson.id || !projectJson.name || !projectJson.state) {
        if (folderSupport && !projectJson.path) {
          callback(null);
        }
      }

      callback(projectJson);
    })
    .catch(() => {});
  callback(null);
};
